import styled from "@emotion/styled";
var TrustWrapper = /*#__PURE__*/ styled("aside", {
    target: "e3ukb4v0"
})("display:flex;flex-direction:column;gap:1rem;position:absolute;bottom:calc(100% - 30px);right:0;");
var TrustElement = /*#__PURE__*/ styled("div", {
    target: "e3ukb4v1"
})("padding:0.5rem;border-radius:", function(param) {
    var theme = param.theme;
    return theme.borderRadius.md;
}, ";border:", function(param) {
    var theme = param.theme, isHighlighted = param.isHighlighted;
    return isHighlighted ? "" : "1px solid ".concat(theme.color.natural20);
}, ";color:", function(param) {
    var theme = param.theme, isHighlighted = param.isHighlighted;
    return isHighlighted ? theme.color.natural0 : theme.color.secondary100;
}, ";background-color:", function(param) {
    var theme = param.theme, isHighlighted = param.isHighlighted;
    return isHighlighted ? theme.color.primary : theme.color.natural0;
}, ";");
var TrustpilotWrapper = /*#__PURE__*/ styled("div", {
    target: "e3ukb4v2"
})("padding:0 0.5rem;text-align:center;");
var TrustpilotBlackPath = /*#__PURE__*/ styled("path", {
    target: "e3ukb4v3"
})("fill:#000;");
var TrustpilotGreenPath = /*#__PURE__*/ styled("path", {
    target: "e3ukb4v4"
})("fill:#00b67a;");
var TrustpilotDarkGreenPath = /*#__PURE__*/ styled("path", {
    target: "e3ukb4v5"
})("fill:#005128;");
var TrustpilotGrayPath = /*#__PURE__*/ styled("path", {
    target: "e3ukb4v6"
})("fill:#cecece;");
var TrustpilotWhitePath = /*#__PURE__*/ styled("path", {
    target: "e3ukb4v7"
})("fill:#fff;");
var AppPromoWrapper = /*#__PURE__*/ styled("div", {
    target: "e3ukb4v8"
})("display:grid;grid-template:'title title' 'stores qr';grid-template-columns:minmax(50px,1fr) max-content;gap:0.5rem;");
var AppPromoHeadline = /*#__PURE__*/ styled("p", {
    target: "e3ukb4v9"
})("grid-area:title;margin:0;font-size:0.75rem;line-height:1.125;strong{display:block;font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";font-size:1.25rem;line-height:1.5;}");
var AppPromoStores = /*#__PURE__*/ styled("ul", {
    target: "e3ukb4v10"
})("grid-area:stores;display:flex;flex-direction:column;gap:0.25rem;margin:0;padding:0;list-style:none;");
var AppPromoQrCode = /*#__PURE__*/ styled("svg", {
    target: "e3ukb4v11"
})("grid-area:qr;shape-rendering:crispedges;width:4.5rem;height:4.5rem;");
export { TrustWrapper, TrustElement, TrustpilotWrapper, TrustpilotBlackPath, TrustpilotGreenPath, TrustpilotDarkGreenPath, TrustpilotGrayPath, TrustpilotWhitePath, AppPromoWrapper, AppPromoHeadline, AppPromoStores, AppPromoQrCode };
